export default "__VITE_ASSET__NfkMNDNN__"